import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseStepComponent } from '../../base';

@Component({
  selector: 'email',
  templateUrl: './email.component.html'
})
export class EmailComponent extends BaseStepComponent {
  @Input() listaEmail: any[];
  @Output() listaEmailChange = new EventEmitter<any[]>();
  @Input() label: string = "";
  @Input() cadastrar: boolean = true;
  @Input() profissional: any;
  cadastro = this.formBuilder.group({
    e_mail: [null, [Validators.required, Validators.email, Validators.maxLength(255)]],
  })

}



// WEBPACK FOOTER //
// ./src/app/Componentes/email/email.component.ts